/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DocumentFolderFromJSON, DocumentFolderToJSON } from './DocumentFolder';
export function GetDocumentFoldersResponseDataFromJSON(json) {
    return GetDocumentFoldersResponseDataFromJSONTyped(json, false);
}
export function GetDocumentFoldersResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        documentFolders: !exists(json, 'document_folders')
            ? undefined
            : json['document_folders'].map(DocumentFolderFromJSON)
    };
}
export function GetDocumentFoldersResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        document_folders: value.documentFolders === undefined ? undefined : value.documentFolders.map(DocumentFolderToJSON)
    };
}
